<div *ngIf="hasLinks" class="separator"></div>

<ul class="nav-links__list">
    <li *ngIf="siteService.features?.askQetaat" class="nav-links__item self-center">
        <a routerLink="/ask-qetaat">
            <button class="btn btn-primary">
                <div class="nav-links__item-body btn-t">{{'ask_qetaat'|translate}}</div>
            </button></a>
    </li>
    <!-- <li *ngIf="siteService.features?.quotationRequests" class="nav-links__item self-center">
        <a routerLink="/request-quotation">
            <button class="btn btn-primary">
                <div class="nav-links__item-body btn-t">{{'request_quotation'|translate}}</div>
            </button>
        </a>

    </li> -->
    <li *ngIf="siteService.features?.blogs" class="nav-links__item">
        <a class="nav-links__item-link" routerLink="/blog">
            <div class="nav-links__item-body">{{'blog'|translate}}</div>
        </a>
    </li>
    <li *ngIf="siteService.features?.multiStore" class="nav-links__item">
        <a class="nav-links__item-link" routerLink="/site/stores">
            <div class="nav-links__item-body">{{'stores'|translate}}</div>
        </a>
    </li>

    <li class="nav-links__item" *ngIf="currentUser?.isVendor; else becomeVendor">
        <a href="/admin" target="_blank" class="nav-links__item-link">
            <div class="nav-links__item-body">{{"admin_panel"|translate}}</div>
        </a>
    </li>
    <ng-template #becomeVendor>
        <li *ngIf="!siteService.siteSetting?.companyId" class="nav-links__item">
            <a class="nav-links__item-link" routerLink="/apply-for-vendor">
                <div class="nav-links__item-body">{{'become_vendor'|translate}}</div>
            </a>
        </li>
    </ng-template>

</ul>